export const PER_PAGE = 200;

// The distance in pixels before the end of the items that will trigger a call to loadMore.
export const SCROLL_THRESHOLD = 400;
